import React from 'react'

import { ZariContext } from '_zari/context'
import { Button, Form, Modal } from '_zari/core'

import { Formik } from 'formik'

import * as UsuarioCrud from 'services/usuario.service'

import * as FormGroups from './formGroups'
import { ValidationSchema } from './validation'

const CambiarContrasenaModal = ({ show, handleClose }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      contrasenaActual: '',
      contrasenaNueva: '',
      contrasenaNuevaRepeat: ''
    }
  }, [])

  const submitHandler = React.useCallback(
    async formData => {
      if (formData.contrasenaNueva !== formData.contrasenaNuevaRepeat) {
        __zariContext.snack('error', 'Las contraseñas nuevas deben ser iguales')
        return
      }

      await UsuarioCrud.self
        .actualizarContrasena(formData)
        .then(() => {
          __zariContext.snack('success', 'La contraseña fue cambiada con exito')
          handleClose()
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
    },
    [__zariContext, handleClose]
  )

  return (
    <Modal show={show} size='sm'>
      <Modal.Header>
        <Modal.Title>CAMBIAR CONTRASEÑA</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ isSubmitting, handleSubmit, errors, touched }) => (
          <Form>
            <Modal.Body>
              <FormGroups.ContraseniaActualFormGroup
                fIsSubmitting={isSubmitting}
                iTouched={touched.contrasenaActual}
                iError={errors.contrasenaActual}
              />
              <FormGroups.ContraseniaNuevaFormGroup
                fIsSubmitting={isSubmitting}
                iTouched={touched.contrasenaNueva}
                iError={errors.contrasenaNueva}
              />
              <FormGroups.ContraseniaNuevaRepeatFromGroup
                fIsSubmitting={isSubmitting}
                iTouched={touched.contrasenaNuevaRepeat}
                iError={errors.contrasenaNuevaRepeat}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button color='primary' disabled={isSubmitting} onClick={handleSubmit}>
                Cambiar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(CambiarContrasenaModal)
